// extracted by mini-css-extract-plugin
module.exports = {"icons":"Icons_icons__30JlK","iconsLi":"Icons_iconsLi__1sBg5","svg":"Icons_svg__1Pr_j"};